import React, { useRef, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import UserBasicDetails from "../userOnboarding/UserBasicDetails";
import RoleSelection from "../userOnboarding/RoleSelection";
import KeyObjectives from "../userOnboarding/KeyObjectives";
import Challenges from "../userOnboarding/Challenges";
import BuildAIAgentprogress from "../userOnboarding/BuildAIAgentprogress";
import OnBoardingVideo from "../../assets/videos/onBoardingVideo.mp4";
import { Grid, Box } from "@mui/material";
import { styled } from '@mui/material/styles';

const StyledVideo = styled('video')(({ theme }) => ({
  width: "100%",
  height: "100vh",
  objectFit: "cover",
}));

const MainVideoContainer = styled(Grid)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  height: '100vh',
  overflow: 'hidden',
}));

const videoRenderSteps = ["start", "role", "objective", "challenge", "build-agent"];

const Onboarding = () => {
  const { step } = useParams();
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video && videoRenderSteps.includes(step)) {
      const stepVideoTimes = {
        start: { start: 0.001, end: 0.001 },
        role: { start: 0, end: 2 },
        objective: { start: 2.1, end: 4 },
        challenge: { start: 4.1, end: 6.1 },
        "build-agent": { start: 6.2, end: 10 },
      };
    
      const { start, end } = stepVideoTimes[step];
      
      video.currentTime = start;
      video.play();

      const pauseVideo = () => {
        if (video.currentTime >= end) {
          video.pause();
        }
      };

      video.addEventListener('timeupdate', pauseVideo);

      return () => {
        video.removeEventListener('timeupdate', pauseVideo);
      };
    }
  }, [step]);

  const renderStep = () => {
    switch (step) {
      case "start":
        return <UserBasicDetails />;
      case "role":
        return <RoleSelection />;
      case "objective":
        return <KeyObjectives />;
      case "challenge":
        return <Challenges />;
      case "build-agent":
        return <BuildAIAgentprogress />;
      default:
        return <Navigate to="/onboarding/start" replace />;
    }
  };

  return (
    <Grid container style={{ background: "#f7f7f7" }}>
      <Grid item xs={7} style={{ marginBottom: '10px' }}>
        {renderStep()}
      </Grid>
      <MainVideoContainer item xs={5}>
        {videoRenderSteps.includes(step) && (
          <Box>
            <StyledVideo
              ref={videoRef}
              muted
              playsInline
            >
              <source src={OnBoardingVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </StyledVideo>
          </Box>
        )}
      </MainVideoContainer>
    </Grid>
  );
};

export default Onboarding;